import { Input } from 'antd'
import styled from 'styled-components'

const BasicInput = styled(Input)`
  &:hover {
    border-color: ${({ theme }): string => theme.colors.brand.primaryHover};
  }
`

export default BasicInput
